export const SET_COOKIE_CONFIRMATION_FULFILLED = 'SET_COOKIE_CONFIRMATION_FULFILLED';
